import { AuthenticatedUser, AuthStore, getCurrentAuthMethod, TokenResponse, UserInfo } from 'auth';
import { UserWithFeatures } from 'types/auth/user-context.type';
import { getAuthHeader } from './get-auth-header';
import { logger } from '@sanlam-glacier/app-common/modules/logger';
import { AuthNavigate } from 'auth/types/auth-navigate.type';
import { routes } from 'routes/route-paths';
import { replaceWithDynamicHost } from 'utils/api/api-host-utils';
import { Env } from 'types/env/Env.type';
import { Configuration, ResultOfAccessResponseViewModel, SecurityApi } from 'bff/client';

type CreateGetAccessProps = {
  getSignedInUser: () => AuthenticatedUser | undefined;
  setSignedInUser: (user: UserInfo) => void;
  setCurrentAuthenticatedUserWithFeatures: (actingAsUser: UserWithFeatures | undefined) => void;
  env: Env;
  navigate: AuthNavigate;
};

const handleOnSuccess =
  (createGetAccessProps: CreateGetAccessProps) => (result: ResultOfAccessResponseViewModel) => {
    const { setSignedInUser, setCurrentAuthenticatedUserWithFeatures, navigate } =
      createGetAccessProps;

    AuthStore.setUserInfo({
      display_name: `${result.data?.userInformation.firstName} ${result.data?.userInformation.surname}`,
      email: result.data?.userInformation.emailAddress ?? '',
      family_name: result.data?.userInformation.surname ?? '',
      given_name: result.data?.userInformation.firstName ?? '',
      sub: result.data?.userInformation.sanpayCode ?? '',
      groups: '',
      guid: '',
      name: result.data?.userInformation.firstName ?? '',
      phone_number: '',
      preferred_username: '',
      nickname: '',
      login: result.data?.userInformation.sanpayCode ?? ''
    });

    setSignedInUser({
      display_name: `${result.data?.userInformation.firstName} ${result.data?.userInformation.surname}`,
      email: result.data?.userInformation.emailAddress ?? '',
      family_name: result.data?.userInformation.surname ?? '',
      given_name: result.data?.userInformation.firstName ?? '',
      sub: result.data?.userInformation.sanpayCode ?? '',
      groups: '',
      guid: '',
      name: result.data?.userInformation.firstName ?? '',
      phone_number: '',
      preferred_username: '',
      nickname: '',
      login: result.data?.userInformation.sanpayCode ?? ''
    });

    setCurrentAuthenticatedUserWithFeatures({
      features: result.data?.features ?? [],
      firstName: result.data?.userInformation.firstName ?? '',
      lastName: result.data?.userInformation.surname ?? '',
      intermediaryCode: result.data?.userInformation.sanpayCode ?? ''
    });

    const noFeatures = result.data?.features.length === 0;

    if (noFeatures) {
      navigate(routes.comingSoon);
    }
  };

export const getAccess =
  (createGetAccessProps: CreateGetAccessProps) =>
  async (authToken?: TokenResponse | undefined): Promise<boolean> => {
    const { env } = createGetAccessProps;
    const { isUsingWebseal } = getCurrentAuthMethod(env);

    const config = new Configuration({
      basePath: replaceWithDynamicHost(env.apiUrl, env.apiHostMappings),
      apiKey: getAuthHeader(
        replaceWithDynamicHost(env.apiUrl, env.apiHostMappings),
        !isUsingWebseal,
        env.auth.gateway.jwtProvider,
        authToken
      ),
      accessToken: authToken?.access_token
    });

    const securityApi = new SecurityApi(config);

    try {
      const response = await securityApi.securityGetAccess({ intermediaryCode: undefined });
      handleOnSuccess(createGetAccessProps)(response);
      return true;
    } catch (error) {
      logger.error({ message: `${error}` });
      return false;
    }
  };
